<template>
  <home-layout>
    <!-- <product-carousel /> -->
    <!-- <category-carousel :category="'smart-apartment'" :id="'carousel-smart-apartment'" />
    <category-carousel :category="'smart-room'" :id="'carousel-smart-room'" />
    <category-carousel :category="'smart-manage'" :id="'carousel-smart-manage'" />
    <category-carousel :category="'cleaning'" :id="'carousel-cleaning'" /> -->
    <div class="row px-3 my-4">
      <div class="col-md-1 col-0 px-0"></div>

      <div class="col-6 col-sm-4 col-md-2 col-lg-2 px-1 container-cid">
        <router-link :to="{ path: '/list', query: { category: 'best-seller'} }">
          <div class="container-cid-in px-0" style="min-height: auto">
            <img src="@/assets/images/category/best-seller.png" alt="" style="min-height: auto">
          </div>
        </router-link>
      </div>

      <div class="col-6 col-sm-4 col-md-2 col-lg-2 px-1 container-cid">
        <router-link :to="{ path: '/list', query: { category: 'smart-building'} }">
          <div class="container-cid-in px-0" style="min-height: auto">
            <img src="@/assets/images/category/smart-building-2.png" alt="" style="min-height: auto">
          </div>
        </router-link>
      </div>

      <div class="col-6 col-sm-4 col-md-2 col-lg-2 px-1 container-cid">
        <router-link :to="{ path: '/list', query: { category: 'smart-room'} }">
          <div class="container-cid-in px-0" style="min-height: auto">
            <img src="@/assets/images/category/smart-room-2.png" alt="" style="min-height: auto">
          </div>
        </router-link>
      </div>

      <div class="col-6 col-sm-4 col-md-2 col-lg-2 px-1 container-cid">
        <router-link :to="{ path: '/list', query: { category: 'smart-manage'} }">
          <div class="container-cid-in px-0" style="min-height: auto">
            <img src="@/assets/images/category/smart-manage-2.png" alt="" style="min-height: auto">
          </div>
        </router-link>
      </div>

      <div class="col-6 col-sm-4 col-md-2 col-lg-2 px-1 container-cid">
        <router-link :to="{ path: '/list', query: { category: 'smart-service'} }">
          <div class="container-cid-in px-0" style="min-height: auto">
            <img src="@/assets/images/category/smart-service-2.png" alt="" style="min-height: auto">
          </div>
        </router-link>
      </div>

      <!-- <div class="col-6 col-sm-4 col-md-2 col-lg-2 px-1 container-cid">
        <router-link :to="{ path: '/list', query: { category: 'cleaning' } }">
          <div class="container-cid-in px-0" style="min-height: auto">
            <img src="@/assets/images/category/cleaning.png" alt="" style="min-height: auto">
          </div>
        </router-link>
      </div> -->

      <!-- <div class="col-6 col-sm-4 col-md-2 col-lg-2 px-1 container-cid">
        <router-link :to="{ path: '/list', query: { category: 'other' } }">
          <div class="container-cid-in px-0" style="min-height: auto">
            <img src="@/assets/images/category/other.png" alt="" style="min-height: auto">
          </div>
        </router-link>
      </div> -->

      <div class="col-md-1 col-0 px-0"></div>
    </div>
    <br/>

    <div class="box-col">
      <div class="row px-2">
        <div class="col-md-7" style="height: 70px;">
          <h3 class="text-topic">{{textTopic}}<small style="font-size:13px;color: #858585;"> ผลลัพธ์ทั้งหมด {{products.length}} ชิ้น</small></h3>
        </div>
        <div class="col-md-5 product-fillter form-inline">
          <div class="form-group fillter-item">
            <label for="inputPassword6" style="margin-right: 10px;">เรียงสินค้าตาม : </label>
            <select class="custom-select" style="width: 170px;" :disabled="isLoading" v-model="currentSortBy" @change="changeSortby()">
              <option value="popular">สินค้ายอดนิยม</option>
              <option value="priceASC">ราคา น้อย - มาก </option>
              <option value="priceDESC">ราคา มาก - น้อย</option>
              <option value="dateDESC">วันที่ลง ใหม่ - เก่า</option>
              <option value="dateASC">วันที่ลง เก่า - ใหม่</option>
            </select>
          </div>
        </div>
      </div>

      <div class="box-loading" v-if="isLoading">
        <loading-worm />
      </div>
      
      <div class="row px-2" v-if="products && !isLoading">
        <div v-for="(product , index) in products.filter(d => !d.get('isSubProduct'))" :key="index" class="col-12 col-sm-4 col-md-3 col-lg-2 list">
          <div class="container-cid" v-if="product">
            <div class="container-cid-in">
              <router-link :to="`/productDetail/${product.id}`" id="parent">
                <span class="box-tag-product">
                  <!-- <span class="tag sale" v-if="product.get('fullPrice') && product.get('fullPrice') - product.get('price') && !product.get('isSpecial')> 0"><b>ลด</b></span> -->
                  <span class="tag special" v-if="product.get('isSpecial')"><b>พิเศษ</b></span>
                  <span class="tag new" v-if="product.get('isNew')"><b>ใหม่</b></span>
                </span>
                
                <img v-if="product.get('images') && product.get('images').length > 0" :src="product.get('images')[0]._url" />

                <p class="product-name">{{product.get('name')}}</p>
                <div v-if="product.get('price')">
                  <p class="price" v-if="!product.get('subProducts')">
                    ฿{{eArabic(product.get('price'))}}
                    <small style="font-size:12px;color: #858585;"> /{{product.get('productCode') == 'CID' ? 'เครื่อง' : product.get('unitType')}}</small>
                  </p>
                  <p class="price" v-else>
                    <span style="font-size: 16px">
                      ฿{{ eArabic(Math.min(...product.get('subProducts').map(d => d.get('price')))) }} - ฿{{ eArabic(Math.max(...product.get('subProducts').map(d => d.get('price')))) }}
                    </span>
                    <small style="font-size:12px;color: #858585;"> /{{product.get('productCode') == 'CID' ? 'เครื่อง' : product.get('unitType')}}</small>
                  </p>
                  <p class="full-price" v-if="product.get('fullPrice') && product.get('fullPrice') - product.get('price') > 0 && !product.get('subProducts')"><span style="text-decoration: line-through;">฿{{eArabic(product.get('fullPrice'))}}</span> ประหยัดไป {{eArabic(product.get('fullPrice') - product.get('price'))}} บาท</p>
                  <p class="full-price" v-else style="color:#fff"> - </p>
                  <!-- <p class="click-detail">ดูรายละเอียดสินค้าเพิ่มเติม</p> -->
                </div>
                <div class="viwe-detail" v-else>
                  <p>ดูรายละเอียดเพิ่มเติม</p>
                  <i class="fa fa-angle-right"></i>
                  <i class="fa fa-angle-right"></i>
                </div>
              </router-link>
              <template v-if="product.get('subProducts')">
                <router-link :to="`/productDetail/${product.id}`" id="parent">
                  <div 
                    v-if="product.get('price') && !product.get('isSoldOut')" 
                    class="add-cart"
                  >
                    <i class="fas fa-list"></i> เลือก
                  </div>
                </router-link>
              </template>
              <template v-else>
                <div 
                  v-if="product.get('price') && !product.get('isSoldOut')" 
                  class="add-cart" @click="addCart(product)"
                >
                  <i class="fas fa-shopping-basket"></i> เพิ่ม
                </div>
              </template>
              <div v-if="product.get('price') && product.get('isSoldOut')" class="add-cart sold-out">สินค้าหมด</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </home-layout>
</template>

<script>
import store from "../store"
import { mapState } from "vuex"
export default {
  data() {
    return {
      products:"",
      isLoading: false,
      textTopic:"สินค้าและบริการของเรา",
      currentSortBy:"popular",
    }
  },
  async mounted() {
    this.isLoading = true
    this.initType()
    this.changeSortby()
  },
  methods:{
    eArabic(x, num = 0) {
      if (x)
        return x.toLocaleString(undefined, {
          minimumFractionDigits: num,
          maximumFractionDigits: num
        });
      else return num == 2 ? "0.00" : "0";
    },
    initType(){ // load fillter
      this.products = []
      this.isLoading = true;
      setTimeout(()=>{
        this.isLoading = false
      },500)
      if(this.$route.params.type && this.$route.params.type == "promotion"){
        this.textTopic = "สินค้าโปรโมชั่น"
        this.allProduct.forEach(r => {
          if(r.get("fullPrice") && r.get("fullPrice") > r.get("price")){
            this.products.push(r)
          }
        })
      }else if(this.$route.params.type && this.$route.params.type == "new"){
        this.textTopic = "สินค้าใหม่"
        this.allProduct.forEach(r => {
          if(r.get("isNew")){
            this.products.push(r)
          }
        })
      }else{
        this.textTopic = "สินค้าและบริการของเรา"
        this.products = this.allProduct
      }
    },
    changeSortby(){
      this.isLoading = true
      if(this.currentSortBy == 'popular'){
        this.products = _.sortBy(this.products , (p) =>{
          return p.get('number')
        }).reverse();
      }else if(this.currentSortBy == 'priceASC'){
        this.products = _.sortBy(this.products , (p) =>{
          if(p.get('price'))
            return p.get('price')
        })
      }else if(this.currentSortBy == 'priceDESC'){
        this.products = _.sortBy(this.products , (p) =>{
          return p.get('price') 
        }).reverse();
      }else if(this.currentSortBy == 'dateDESC'){
        this.products = _.sortBy(this.products , (p) =>{
          if(!p.get('isNew')){
            return p.get('createdAt')
          }
        }).reverse();
      }else{
        this.products = _.sortBy(this.products , (p) =>{
          return p.get('createdAt')
        })
      }
      setTimeout(()=>{
        this.isLoading = false
      },200)
    },
    async addCart(product){
      // if(!this.user){
      //   $('#modalLogin').modal('show')
      // }else{

        // ------------------------mixpanel---------------------------
        if(this.user) this.$mixpanel.track(`click-add-cart`, {from: "home", product: product.id , id : this.user.id , tel : this.user.get('tel') , name : this.user.get('userProfile').get('firstName')})
        else this.$mixpanel.track(`click-add-cart`, {from: "home", product: product.id})
        // -----------------------------------------------------------

        let objCart = {
          productId: product.id,
          number: 1
        }

        if(localStorage.getItem('carts')){
          if(JSON.parse(localStorage.getItem('carts')).findIndex(item => item.productId === product.id) <= -1){
            let carts = JSON.parse(localStorage.getItem('carts'))
            let balanceStore = await this.Parse.Cloud.run("MarketProduct_countBalanceStore",{productId : product.id});

            carts.push(objCart)

            localStorage.setItem('carts',JSON.stringify(carts))
            store.commit('setCarts', carts)
            store.commit('addHashBalanceProduct', balanceStore)
          }
        }else{
          localStorage.setItem('carts',JSON.stringify([objCart]))
          store.commit('setCarts', [objCart])
        }
        $("#addCartToast").addClass('show')
        $("#addCartToast").removeClass('hide')

        setTimeout(function(){
          $("#addCartToast").removeClass('show')
          $("#addCartToast").addClass('hide')

        },2000)

      }
    // }
  },
  computed: {
    ...mapState([
      'user',
      'allProduct'
    ])
  },
  watch: {
    '$route.params.type': function(){
      this.initType()
      this.changeSortby()
    }
  },
};
</script>
<style scoped>
.box-loading{
  text-align: center;
  transform: scale(1.3);
  margin-top: 40px;
  margin-bottom: 20px;
}
a {
  text-decoration: none;
}
.list {
  height: auto;
  padding: 10px;
  width: 100%;
  transition: all 200ms;
  /* box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.3); */
  background-color: #ffffff;
  z-index: 1;
  font-size: 14px;
}

#parent{
  transition: all 200ms;
}
#parent:hover {
  opacity: .8;
}
.main {
  text-align: center;
  padding: 20px;
  position: relative;
  display: block;
}
.productName {
  color: black;
  margin: 0 0 5px 0;
  min-height: 72px;
}
.add-cart{
  margin-top: 10px;
  background: #e9773b;
  color: white;
  width: 100%;
  padding: 8px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: bold;
  transition: all 200ms;
  border: 1px solid #e9773b;
}
.add-cart:hover:not(.sold-out){
  /* background: #da6d33; */
  background-color: white;
  color: #e9773b;
}
.add-cart:hover:not(.sold-out) i{
  color: #e9773b;
}
/* .add-cart{
  margin-top: 10px;
  color: #e9773b;
  width: 100%;
  padding: 8px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 300ms;
  border: 1px solid #e9773b;
}
.add-cart:hover:not(.sold-out){
  background: #da6d33;
  color: white;
} */
.add-cart.sold-out{
  cursor: default;
  background: white;
  border: 1px solid rgba(148, 148, 148);
  color: rgba(148, 148, 148);
}
img {
  width: 100%;
  height: auto;
}
.btnWatchDetail {
  padding: 0;
  background-color: #e9773b;
  border: none;
  padding-left: 6px;
  padding-right: 6px;
  border-radius: 5px;
  color: #ffffff;
  box-shadow: 3px 2px 10px rgba(233, 120, 59, 0.705);
}
.btnWatchDetail p {
  margin: 0;
  font-size: 14px;
}
.box-tag-product{
  position: absolute;
}
.box-tag-product .tag{
  margin-bottom: 20px;
  display: block;
	background:red;
	color: white;
	height: 2.5rem;
	width: 2.5rem;
	text-align: center;
	line-height: 2.5rem;
	transform: rotate(-20deg);
	animation: beat 1s ease infinite alternate;
}
.box-tag-product .tag.new{
  background: #5849ec;
}
.box-tag-product .tag.special{
  background: #fa9d0f;
}
.box-tag-product .tag:before , .box-tag-product .tag:after{
    content:"";
		position: absolute;
		background: inherit;
		height: inherit;
		width: inherit;
		top: 0;
		left: 0;
		z-index: -1;
		transform: rotate(30deg);
}
.box-tag-product .tag:after{
  transform: rotate(60deg);
}
@keyframes beat {
	from {	transform: rotate(-20deg) scale(1); }
	to {	transform: rotate(-20deg) scale(1.1); }
}
i {
  color: #eaeaea;
}
.starActive {
  color: #e9773b;
}
.viwe-detail {
  /* border: 1px solid black; */
  position: relative;
  margin-top: 40px;
}
.viwe-detail p {
  margin: 0;
  display: inline;
  color: rgb(224, 134, 85);
  padding-top: -20px;
}
.viwe-detail i {
  position: relative;
  top: 6px;
  left: 6px;
  font-size: 33px;
}
.viwe-detail i:nth-child(1) {
  color: rgba(231, 138, 88, 0.644);
  margin-right: -7px;
}
.viwe-detail i:nth-child(2) {
  color: rgb(233, 119, 59, 0.9);
}
.price{
  color: #e9773b;
  text-align: left;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 0;
}
.full-price{
  color: #5c5c5c;
  text-align: left;
  font-size: 12px;
  margin-bottom: 5px;
}
.click-detail{
  text-align: right;
  font-size: 14px;
  color: black;
  margin-bottom: 0;
}
#parent:hover .click-detail{
  text-decoration: underline;
}
.text-topic{
  font-weight: bold;
  font-size: 27px;
  color: rgb(80, 80, 80);
  height: 45px;
}

/* .viwe-detail .icon-item{
  right: 20px;
}
.viwe-detail i{
  margin: 0;
  font-size: 37px;
}
.viwe-detail i:nth-child(1){
  color: rgb(238, 139, 85);
  position: absolute;
  top: -7px;
  right: 0;
}
.viwe-detail i:nth-child(2){
  color: rgb(235, 188, 163);
  position: absolute;
  top: -7px;
  right: 12px;
} */
</style>

